import { ColorDynamic, Column, Columns, Stack } from '@superdispatch/ui';
import { TaxPriceDTO } from '../SubscriptionDTO';
import { Typography } from '@material-ui/core';
import { formatDate } from '@superdispatch/dates';
import styled from 'styled-components';
import { formatCurrency } from 'shared/helpers/IntlHelpers';

const InformationDivider = styled.div`
  border-bottom: 1px dotted ${ColorDynamic.Silver400};
  height: 18px;
`;

interface PastDueInvoiceProps {
  pastDueInvoices: TaxPriceDTO['past_due_invoices'];
}

export function PastDueInvoice({ pastDueInvoices }: PastDueInvoiceProps) {
  return (
    <Stack space="xsmall">
      {pastDueInvoices?.map((invoice) => {
        return (
          <Columns key={invoice.guid} space="xsmall">
            <Column width="content">
              <Stack space="xxsmall">
                <Typography variant="body1">Past due amount</Typography>
                <Typography color="textSecondary">
                  For {formatDate(invoice.due_at, { variant: 'ShortDate' })}
                </Typography>
              </Stack>
            </Column>
            <Column width="fluid">
              <InformationDivider />
            </Column>
            <Column width="content">
              <Typography variant="h4">
                {formatCurrency(invoice.amount_due)}
              </Typography>
            </Column>
          </Columns>
        );
      })}
    </Stack>
  );
}

export function getPastDueTotal(
  pastDueInvoices: TaxPriceDTO['past_due_invoices'] | undefined,
): number {
  return (pastDueInvoices || []).reduce(
    (total, invoice) => total + (invoice.amount_due ?? 0),
    0,
  );
}
